/** API route map: URLS.Controller.EeoPositionClassification */
export const EeoPositionClassification = {
      Name: 'EeoPositionClassification/',
      GetAll: 'get-all-paginated',
      GetGroupCodes: 'get-group-codes',
      GetWcClassCodes: 'get-wc-class-codes',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
};
